<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="120px"
            size="mini"
          >
           <el-form-item label="经销商名称" prop="customerName"> 
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applyUser">
              <el-input
                v-model="searchForm.applyUser"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="searchForm.status" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" startFiled="createdDateStart" endFiled="createdDateEnd" :isDefault="false"/>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportFile">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="customerCode" label="经销商编码" align="center" width="120"></el-table-column>
          <el-table-column prop="customerName" label="经销商名称"  align="center" width="150"></el-table-column>
          <el-table-column prop="walletTypeStr" label="钱包类型" align="center" width="120"></el-table-column>
          <el-table-column prop="walletBalance" label="调整前钱包余额" align="center" width="120"></el-table-column>
          <el-table-column prop="adjustAmount" label="调账减少金额" align="center" width="130"></el-table-column>
          <el-table-column prop="afterBalance" label="调账后钱包余额" align="center" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyUser" label="申请人" align="center" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyReason" label="申请原因" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="80"></el-table-column>
          <el-table-column prop="createdBy" label="操作人" align="center" width="120"></el-table-column>
          <el-table-column prop="createdDate" label="操作时间" align="center" width="160"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import moment from "moment";
export default {
  mixins: [tableMixin],
  name: "walletRecord",
  data() {
    return {
      searchForm: {
        customerName: '',
        applyUser: '',
        status: '',
        createdDateStart: '',
        createdDateEnd: ''
      },
      statusOptions: [
        {value: '', label: '全部'},
        {value: '成功', label: '成功'},
        {value: '失败', label: '失败'}
      ],
      operationType: [
        {value: '', label: '全部'},
        {value: 1, label: '支出'},
        {value: 2, label: '支入'},
      ],
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowImportDialog: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryWalletAdjustList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) { 
        if (typeof val !== "undefined" && val !== null && val !== "") {
          if (key === "createdDateStart" || key === "createdDateEnd") {
            this.filterParam[key] = moment(val).format('YYYYMMDD');
            continue;
          }
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createdDateStart = ''
      this.searchForm.createdDateEnd = ''
      this.$refs.dateRef.reset()
    },
    exportFile() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryWalletAdjustList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>

</style>
